import { PERMISSION_ACTION_VIEW, PERMISSION_ENTITY_INVOICE_OFFER } from '@klear/constants'
import { useAuth } from '@klear/ui/contexts/auth-context'
import { trpc } from '@klear/ui/lib/trpc'

export const useFunderAccounts = () => {
  const { user } = useAuth()
  const { data: funderAccounts, isLoading } = trpc.funder.list.useQuery(
    {},
    {
      enabled: user.hasPermission(PERMISSION_ENTITY_INVOICE_OFFER, PERMISSION_ACTION_VIEW)
    }
  )

  return {
    funderAccounts,
    isLoading
  }
}
